<ng-container *transloco="let t">
  <div class="flex flex-col -m-6">
    <div class="flex flex-0 sticky -top-6 z-50 items-center justify-between h-16 pr-3 sm:pr-5 pl-6 sm:pl-8 bg-primary text-on-primary">
      <div class="text-lg font-medium">{{ 'services.dialog.changeRepoName.title' | transloco }}: {{areaName}}</div>
    </div>

    <div class="w-full flex flex-col p-8">
      <mat-label class="fuse-mat-no-subscript p-2 mt-2">{{ 'services.dialog.changeRepoName.label' | transloco }}</mat-label>
      <mat-form-field class="fuse-mat-no-subscript p-2">
        <input [formControl]="nameControl" [placeholder]="data" matInput type="text">
      </mat-form-field>
      @if (errorLength) {
        <mat-error class="ml-3">
          {{ 'services.dialog.changeRepoName.tooLong' | transloco }}
        </mat-error>
      }
      @if (patternError) {
        <mat-error class="ml-3">
          {{ 'services.dialog.changeRepoName.patternError' | transloco }}
        </mat-error>
      }
      @if (equalError) {
        <mat-error class="ml-3">
          {{ 'services.dialog.changeRepoName.equalError' | transloco }}
        </mat-error>
      }
      @if (nameControl.touched && nameControl.errors?.required) {
        <mat-error class="ml-3">
          {{ 'errorRequiredField' | transloco }}
        </mat-error>
      }

      <div class="flex flex-row justify-end pt-4">
        <button mat-flat-button class="mr-8" color="warn" (click)="saveName('cancel')">{{ 'cancel' | transloco }}</button>
        <button mat-flat-button class="mr-8" color="primary" (click)="saveName('save')">{{ 'save' | transloco }}</button>
      </div>
    </div>

  </div>
</ng-container>
